import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useChart } from '../../chart';
import i18n from '../../../i18n';
// components

export default function PieChartEmpty({ height = 280, title, subtitle }) {
    const theme = useTheme();

    const options = useChart({
        labels: [i18n.t('common.noData') || 'No data'],
        colors: [theme.palette.action.disabledBackground],
        legend: { show: false },
        tooltip: { enabled: false },
        dataLabels: { enabled: false, formatter: () => '' },
        plotOptions: {
            pie: {
                expandOnClick: false,

                donut: {
                    labels: {
                        show: false
                    }
                }
            }
        },
        stroke: { show: false },
        states: {
            hover: { filter: { type: 'none' } },
            active: { filter: { type: 'none' } }
        }
    });

    return (
        <Box sx={{ position: 'relative', height }}>
            <ReactApexChart
                type="pie"
                series={[1]}
                options={options}
                height={height}
            />

            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    px: 2,
                    pointerEvents: 'none'
                }}
            >
                <Box>
                    <Typography variant="subtitle2" color="text.primary">
                        {title || i18n.t('common.noData')}
                    </Typography>

                    {subtitle && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                        >
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
}

PieChartEmpty.propTypes = {
    height: PropTypes.number,
    title: PropTypes.string,
    subtitle: PropTypes.string
};
